import React from "react";

const Facebook = ({ ClickHandler }) => {
  const Sms = () => {
    window.alert('"Түр засвартай байна..."');
  };
  return (
    <a
      onClick={Sms}
      // className="facebook"
      // href="https://www.facebook.com/mongolsuvdchurch/"
      // rel="nofollow noreferrer"
      // target="_blank"
    >
      <i className="fab fa-facebook-f"></i>
    </a>
  );
};

export default Facebook;
